import React from 'react';

const CccDashboardHeader: React.FC = () => (
  <div className="dashboard-header">
    <div className="header-content">
      <h1>Dashboard CallCenter Comercial</h1>
      <p className="header-subtitle">
        Monitorização diária — clientes em tratamento e pedidos de proposta
      </p>
    </div>
  </div>
);

export default CccDashboardHeader;
